import * as React from 'react';

export interface LogoutIconProps {
  className?: string;
  color?: string;
  size?: number;
}

export const LogoutIcon: React.FC<LogoutIconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={props.className}
  >
    <g clipPath="url(#clip0_40151_14778)">
      <path
        d="M0.96875 8.00244H10.8125"
        stroke="black"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.46875 10.3462L10.8125 8.00244L8.46875 5.65869"
        stroke="black"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.56641 10.8749C3.21143 12.2 4.28373 13.2695 5.61056 13.9109C6.9374 14.5524 8.44153 14.7286 9.8807 14.4111C11.3199 14.0936 12.6103 13.3009 13.5441 12.1608C14.4779 11.0206 15.0007 9.59928 15.0283 8.12577C15.056 6.65227 14.5868 5.21235 13.6964 4.03795C12.8061 2.86355 11.5463 2.02304 10.12 1.6518C8.69381 1.28057 7.18412 1.40021 5.83416 1.99147C4.4842 2.58273 3.37255 3.61119 2.67828 4.91117"
        stroke="black"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_40151_14778">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default LogoutIcon;
